export default function(instance){
    return{
        GetPagedByCategoryId(payload){
            return instance.get(`/Product/GetPagedByCategoryId?pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}&categoryId=${payload.categoryId}`);
        },
    }
}
